/**
 * 转换label
 * @param dataIndexName 需要转换的后端字段名
 */
export const formatNameString = (input: string) => {
  let result = '';
  for (let i = 0; i < input.length; i++) {
    const currentChar = input[i];
    if (i === 0) {
      result += currentChar.toUpperCase();
    } else if (currentChar === currentChar.toUpperCase()) {
      result += ` ${currentChar}`;
    } else {
      result += currentChar;
    }
  }
  return result;
};

export const getColorByStatus = (
  status: string,
  isBackground: boolean,
  isBorder: boolean
): string => {
  let color = '';
  switch (status) {
    case 'BEING_PROCESSED':
      color = isBackground ? '#FEF5E9' : isBorder ? '#F6C172' : '#F19F23';
      break;
    case 'OPEN':
      color = isBackground ? '#F9F2F9' : isBorder ? '#C279BE' : '#9E2896';
      break;
    case 'COMPLETE':
      color = isBackground ? '#F1F8F7' : isBorder ? '#84BDBA' : '#18837E';
      break;
    case 'DRAFT':
      color = isBackground ? '#DEF5F3' : isBorder ? '#18837E' : '#18837E';
      break;
    default:
      color = isBackground ? '#F2F3F4' : isBorder ? '#B2B9C0' : '#A0A0A0';
      break;
  }
  return color;
};
